import { render, staticRenderFns } from "./SellBusinessDetails.vue?vue&type=template&id=6df7b35c&scoped=true&"
import script from "./SellBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./SellBusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./SellBusinessDetails.vue?vue&type=style&index=0&id=6df7b35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df7b35c",
  null
  
)

export default component.exports